module.exports = __webpack_public_path__ + "assets/img/travel4.9da6ace2.png";